import { render, staticRenderFns } from "./SynonymsReadingEn.vue?vue&type=template&id=00e36880&lang=pug&"
import script from "./SynonymsReadingEn.vue?vue&type=script&lang=js&"
export * from "./SynonymsReadingEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports